import React, { type FC, type ReactElement } from 'react'
import { Typography, Flex, Layout } from 'antd'

import { MSLayoutContentRow } from '@choreograph/layout'

const { Header } = Layout
const { Title } = Typography

export interface IWppLayoutHeaderProps {
  appName: string
  appLogo?: ReactElement
  extraContent?: ReactElement
}

export const WppLayoutHeader: FC<IWppLayoutHeaderProps> = ({ appName, appLogo, extraContent }) => {
  return (
    <Header className='wpp-header__container'>
      <MSLayoutContentRow>
        <Flex justify='space-between' align='center'>
          <Flex gap='middle' align='center'>
            {appLogo}
            <Title level={4} className='wpp-header__app-name'>
              {appName}
            </Title>
          </Flex>
          <Flex align='center' gap={24}>
            {extraContent}
          </Flex>
        </Flex>
      </MSLayoutContentRow>
    </Header>
  )
}
